// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__Vwki3","spinner-border":"spinner_spinner-border__sMYHh","sr-only":"spinner_sr-only__GiDrX","overlay":"spinner_overlay__+cMTL"};